<div class="homeButtonsArea row">	  
    <div class="col-md-4 col-sm-6">
        <div 
            class="homeButton"
            routerLinkActive="active" 
            [routerLink]="['/tariffs']"        
        >
            <i class="icon icon-tariff"></i>
            <h2> {{ 'HOME_TARIFFS_LABEL' | translate}}</h2>
        </div>
    </div>	
    <div class="col-md-4 col-sm-6">
      <div class="homeButton" (click)="openFaqModal()">
          <i class="icon icon-faq"></i>
          <h2>{{ 'HOME_FAQ_LABEL' | translate}}</h2>
      </div>
  </div>	
  <div class="col-md-4 col-sm-6">
        <div 
            class="homeButton"         
            routerLinkActive="active" 
            [routerLink]="['/feedback']"
        >
          <i class="icon icon-menu_feedback"></i>
          <h2>{{ 'HOME_FEEDBACK_LABEL' | translate }}</h2>
      </div>
    </div>	
</div>